<script setup>
  import { ref, computed } from "vue";
  import { useRouter, useRoute } from "vue-router";
  import { auth, logOut } from "@/firebase/firebase";

  const router = useRouter();
  const route = useRoute();
  const pageTitle = computed(() => route.meta.title);
  const drawer = ref(null);
  const currentUser = ref();

  auth.onAuthStateChanged(function (user) {
    currentUser.value = user;
  });

  const onSignOut = async function () {
    const result = await logOut();
    if (result) {
      router.push({ name: "login" });
    } else {
      alert("ログアウトに失敗しました");
    }
  };

  const toCreateCoupon = async function () {
    drawer.value = null;
    router.replace({ name: "createCoupon" });
  };

  const toCouponList = async function () {
    drawer.value = null;
    router.replace({ name: "couponList" });
  };

  const toCouponUsedList = async function () {
    drawer.value = null;
    router.replace({ name: "couponUsedList" });
  };
</script>

<template>
  <v-app>
    <v-toolbar color="blue" prominent>
    </v-toolbar>
    <v-app-bar color="blue">
      <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer">
      </v-app-bar-nav-icon>

      <v-app-bar-title>
        {{ pageTitle }}
      </v-app-bar-title>
      <v-btn style="text-transform: none" v-if="currentUser" color="white" @click="onSignOut">サインアウト
      </v-btn>
    </v-app-bar>
    <v-layout>
      <v-navigation-drawer v-model="drawer" floating permanent v-if="currentUser">
        <v-list density="compact" nav>
          <v-list-item @click="toCreateCoupon" prepend-icon="mdi-view-dashboard" title="クーポン発行" value="createCoupon" />
          <v-divider />
          <v-list-item @click="toCouponList" prepend-icon="mdi-view-list" title="クーポン一覧" value="couponList" />
          <v-divider />
          <v-list-item @click="toCouponUsedList" prepend-icon="mdi-star" title="使用済一覧" value="couponUsedList" />
        </v-list>
      </v-navigation-drawer>
      <v-main style="background: #e8eaed">
        <router-view />
      </v-main>
    </v-layout>
  </v-app>
</template>
